import ActionHelper from '@module/redux-actions';

export const actions = ActionHelper.types([
  'SHOW_UI',
  'HIDE_UI',
  'SET_WALLPAPER_UI_STYLE',
  'RESET_WALLPAPER_UI_STYLE',
]);

export default ActionHelper.generate({
  showUI: [actions.SHOW_UI],
  hideUI: [actions.HIDE_UI],
  setWallpaperUIStyle: [actions.SET_WALLPAPER_UI_STYLE, 'styles'],
  resetWallpaperUIStyle: [actions.RESET_WALLPAPER_UI_STYLE],
});
